import { createTheme } from '@mui/material/styles';
import { ptBR as corePtBR } from '@mui/material/locale';
import { ptBR } from '@mui/x-data-grid';
import { ptBR as pickersPtBR } from '@mui/x-date-pickers';
import type {} from '@mui/x-data-grid/themeAugmentation';
import { Perfil } from 'src/constants/Perfil';
import { paletteQuebradeira } from './paletteQuebradeira';
import { paletteEntreposto } from './paletteEntreposto';
// import { PaletteOptions } from '@mui/material';

ptBR.components.MuiDataGrid.defaultProps.localeText = {
  ...ptBR.components.MuiDataGrid.defaultProps.localeText,
  toolbarQuickFilterPlaceholder: 'Buscar...',
  toolbarQuickFilterLabel: 'Buscar',
  toolbarQuickFilterDeleteIconLabel: 'Limpar busca',
};

export const getTheme = (perfil?: Perfil | null) => {
  const palette = perfil === Perfil.ENTREPOSTO ? paletteEntreposto : paletteQuebradeira;
  const theme = createTheme(
    {
      palette,
      components: {
        MuiDrawer: {
          styleOverrides: {
            root: {
              '& .MuiDrawer-paper': {
                backgroundColor: palette.primary.main,
              },
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              borderRadius: '4px 4px 0px 0px',
              width: '100%',
              '&.Mui-required .MuiFormLabel-asterisk': {
                // color: '#F00'
              },
            },
          },
        },
        MuiListItemButton: {
          styleOverrides: {
            root: {
              borderRadius: 20,
              marginBottom: 8,
              marginLeft: 8,
              marginRight: 8,

              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.5)',
              },

              '&.Mui-selected': {
                backgroundColor: palette.primary.variants[50],
              },

              '&.light:hover': {
                backgroundColor: palette.primary.variants[80],
              },
            },
          },
        },
        MuiDataGrid: {
          styleOverrides: {
            root: {
              backgroundColor: palette.formCard.main,
              '& .MuiDataGrid-columnHeaderTitle': {
                overflow: 'visible',
                lineHeight: '1.43rem',
                whiteSpace: 'normal',
              },
              '& .MuiDataGrid-row': {
                backgroundColor: palette['surface-background'].main,
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: palette['surface-background'].contrast,
                fontWeight: 500,
              },
              // '& .MuiDataGrid-row:nth-of-type(2n)':{
              //   backgroundColor: palette.primary.variants[95],
              //   color:palette.primary.variants[0],
              // }
            },
            cell: {
              // backgroundColor: 'yellow'
            },
            columnHeader: {
              backgroundColor: palette.tableColumnHeader.main,
            },
          },
        },
        MuiTabs: {
          styleOverrides: {
            root: {
              backgroundColor: palette.formCard.main,
              marginTop: 20,
            },
          },
        },
      },
    },
    corePtBR,
    ptBR,
    pickersPtBR
  );
  return theme;
};
